import React, { useEffect, useState } from "react";
import { PopupModal } from "../Components";
import { SettingNavbarComponent } from "../Components/navbar/settingsnav";
import { MdOutlineEdit } from "react-icons/md";
import { FormParser } from "../Components";
import Masters from "../Components/masters.json";
import axiosConfig from "../Service/axiosConfig";
import SiteDeliveryOptions, {
  deliveryOptionsFromSite,
  getDefaultDeliveryOptions,
  normalizeDeliveryForSubmit,
} from "./SiteDeliveryOptions";
import "./Pages.css";

const Sitesetting = () => {
  const MastersModal = Masters.SiteSettings;
  const [siteSettings, setSiteSettings] = useState([]);
  const [deliveryOptions, setDeliveryOptions] = useState(getDefaultDeliveryOptions);
  const [readOnly, setReadOnly] = useState(true);
  const [message, setMessage] = useState(null);
  const [show, setShow] = useState(false);
  const [Error, SetError] = useState("");
  const [popupType, setpopupType] = useState("");
  const handleShow = () => {
    setShow(true);
  };
  const GetSiteSettings = async () => {
    try {
      const responce = await axiosConfig.get(`/sitedata/site/`);
      console.log(responce.data.results[0], "site settings");
      if (responce.data.results.length > 0) {
        let site_settings = {
          ...responce.data.results[0],
          template: responce.data.results[0].template?.id,
          business_category: responce.data.results[0].business_category?.id,
        };
        setSiteSettings(site_settings);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formSubmit = async (Data) => {
    try {
      const updatedData = { ...Data };
      updatedData.logo = Data.logo.id;
      updatedData.favicon = Data.favicon.id;
      updatedData.banner = Data.banner.id;
      console.log(updatedData, "updatedData");
      if((updatedData.pan_no.length > 10 || updatedData.pan_no.length < 10) && updatedData.pan_no){
        setpopupType("error");
        SetError("Please enter valid PAN number");
        return
      }
      if((updatedData.gsttin.length > 15 || updatedData.gsttin.length < 15) && updatedData.gsttin){
        setpopupType("error");
        SetError("Please enter valid GST number");
        return
      }
      if((updatedData.fssai.length > 14 || updatedData.fssai.length < 14) && updatedData.fssai){
        setpopupType("error");
        SetError("Please enter valid GST number");
        return
      }
      if(updatedData.pincode.length > 6 || updatedData.pincode.length < 6){
        setpopupType("error");
        SetError("Please enter valid pincode");
        return
      }
      const formData = new FormData();
      const alwaysIncludeFields = [
        "default_primary",
        "default_secondary",
        "express_delivery",
        "deliver_slot_by_today",
        "delivery_for_selected_date_slot",
      ];
      Object.entries(updatedData).forEach(([key, value]) => {
        if (alwaysIncludeFields.includes(key)) {
          formData.append(key, value);
        } else if (value || value === "") {
          formData.append(key, value);
        }
      });
      axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
      if (Data.id) {
        const response = await axiosConfig.patch(
          `/sitedata/site/${Data.id}/`,
          formData
        );
        console.log("updated site settings successfully : ", response);
        setMessage("Site settings updated successfully");
      } else {
        const response = await axiosConfig.post(`/sitedata/site/`, formData);
        console.log("created site settings successfully : ", response);
        setMessage("Site settings created successfully");
      }
      setpopupType("success");
      setReadOnly(true);
    } catch (error) {
      console.log("Error setting the site data:", error.response.data);
      setpopupType("error");
      const errorValues = Object.values(error.response.data.error);
      const errorKeys = Object.keys(error.response.data.error);
      if (errorValues.length > 0 && errorValues[0].length > 0) {
        SetError(`${errorValues[0][0]} at ${errorKeys[0]}`);
      }
    }
  };

  const handleFormSubmit = async (Data, setFieldErrors) => {
    const delivery = normalizeDeliveryForSubmit(deliveryOptions);
    await formSubmit({ ...Data, ...delivery }, setFieldErrors);
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    console.log(e.target, name, "banner check");
    if (file) {
      setSiteSettings((prev) => ({
        ...prev,
        [name]: file,
      }));
    }
    let ddd = siteSettings;
    console.log({ ...ddd, [name]: file }, "inside handlefilechange......");
  };

  useEffect(() => {
    GetSiteSettings();
  }, []);

  useEffect(() => {
    if (
      !siteSettings ||
      typeof siteSettings !== "object" ||
      Array.isArray(siteSettings) ||
      !siteSettings.id
    ) {
      return;
    }
    setDeliveryOptions(deliveryOptionsFromSite(siteSettings));
  }, [siteSettings?.id]);

  return (
    <>
      <div className="child-sidenav">
        <SettingNavbarComponent />
        <div className="childnav-content mt-2">
          <FormParser
            modelObject={MastersModal}
            buttonTitle="Save"
            readOnly={readOnly}
            setReadOnly={setReadOnly}
            formData={siteSettings}
            formSubmit={handleFormSubmit}
            error={Error}
            beforeSubmit={
              <SiteDeliveryOptions
                options={deliveryOptions}
                onOptionsChange={setDeliveryOptions}
                readOnly={readOnly}
              />
            }
          />
          {popupType != "" && (
            <PopupModal
              popupType={popupType}
              setpopupType={setpopupType}
              Navigation="/dashboard/masters/sitesettings"
              Message={message}
              error={Error}
            />
          )}
          {readOnly && (
            <button
              className={`btn btn-primary d-flex align-items-center`}
              onClick={() => setReadOnly(false)}
            >
              <div>Edit</div>
              <MdOutlineEdit className="ms-5" />
            </button>
          )}
        </div>
      </div>
    </>
  );
};
export { Sitesetting };
